import { Box, setAlpha, Stack, ThemeTypes } from '@talos/kyoko';
import styled from 'styled-components';

export const LayoutOptionType = styled(Box)`
  position: absolute;
  background: ${({ theme }) => setAlpha(0.1, theme.colors.gray['100'])};
  transition:
    background 0.2s ease-in-out,
    color 0.2s ease-in-out;
`;
LayoutOptionType.defaultProps = {
  color: 'colorTextDefault',
  bottom: 'spacing16',
  right: 'spacing16',
  borderRadius: 'borderRadiusDefault',
};

export const LayoutOptionWrapper = styled(Stack).attrs<{ selected?: boolean }>(({ selected }) => ({
  as: 'button',
  type: 'button',
  'data-selected': selected,
}))<{ selected?: boolean }>`
  border-radius: 0.75rem;
  cursor: pointer;
  border: 2px solid transparent;
  color: var(--color-text-default);
  text-align: left;
  background: transparent;
  position: relative;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  width: 100%;

  &:hover {
    border: 2px solid var(--colors-gray-050);
    ${({ theme }) => (theme.type === ThemeTypes.dark ? 'filter: brightness(1.2);' : 'filter: brightness(0.95);')}

    > span {
      color: var(--color-text-attention);
    }
  }

  ${({ selected, theme }) =>
    selected &&
    (theme.type === ThemeTypes.dark
      ? `&, &:hover {
      color: var(--color-text-important);
      border: 2px solid var(--colors-gray-100);
      filter: brightness(1.1);
    }
  `
      : `&, &:hover {
      color: var(--color-text-important);
      border: 2px solid var(--colors-gray-100);
      filter: brightness(0.92);
    }
  `)}
`;
LayoutOptionWrapper.defaultProps = {
  p: 'spacing8',
  gap: 'spacing8',
};
